import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Eamon Miller </span>
            from <span className="purple"> Ontario, Canada.</span>
            <br />I am a junior web dev and alumni from the University of Guelph.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Gaming
            </li>
            <li className="about-activity">
              <ImPointRight /> Designing Products
            </li>
            <li className="about-activity">
              <ImPointRight /> Napping zzz
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Eamon Miller</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
